export const particlesOptions = {
  background: {
    color: {
      value: "#181818",
    },
  },
  interactivity: {
    detectsOn: "window",
    events: {
      onClick: {
        enable: true,
        mode: "connect",
      },
      onHover: {
        enable: true,
        mode: "connect",
        parallax: {
          enable: false,
          force: 20,
          smooth: 20,
        },
      },
      resize: true,
    },
    modes: {
      connect: {
        distance: 60,
        speed: 1,
        duration: 100,
        links: {
          opacity: 0.3,
        },
        radius: 100,
      },
    },
  },
  particles: {
    reduceDuplicates: true,
    number: {
      value: 300,
      limit: 300,
    },

    color: {
      value: ["#20ade3", "#19ae54", "#80ed99"], // Colors preset
    },
    shape: {
      type: "circle",
      stroke: {
        width: 0,
        color: "#000000",
      },
      polygon: {
        sides: 1,
      },
    },

    opacity: {
      value: 0.3,
    },

    size: {
      value: { min: 1, max: 1 },
      animation: {
        enable: true,
        speed: 10,
        startValue: "random",
        sync: true,
      },
    },

    move: {
      enable: true,
      speed: 8,
      direction: "none",
      random: false,
      straight: true,
      outModes: "out",
      attract: {
        enable: false,
        rotateX: 600,
        rotateY: 600,
      },
    },
    life: {
      duration: 30,
      count: 1,
    },
  },
  detectRetina: true,
};

export const particlesOptionsMobile = {
  background: {
    color: {
      value: "#181818",
    },
  },
  interactivity: {
    detectsOn: "window",
    events: {
      onClick: {
        enable: true,
        mode: "remove",
      },
      onHover: {
        enable: true,
        mode: "remove",
        parallax: {
          enable: false,
          force: 20,
          smooth: 20,
        },
      },
      resize: true,
    },
  },
  particles: {
    reduceDuplicates: true,
    number: {
      value: 60,
      limit: 60,
    },

    color: {
      value: ["#20ade3", "#19ae54", "#80ed99"], // Colors preset
    },
    shape: {
      type: "circle",
      stroke: {
        width: 0,
        color: "#000000",
      },
      polygon: {
        sides: 1,
      },
    },

    opacity: {
      value: 0.4,
    },

    size: {
      value: { min: 1, max: 1 },
      animation: {
        enable: true,
        speed: 8,
        // startValue: "random",
        sync: true,
      },
    },

    move: {
      enable: true,
      speed: 8,
      direction: "none",
      random: false,
      straight: true,
      outModes: "out",
      attract: {
        enable: false,
        rotateX: 600,
        rotateY: 600,
      },
    },
    life: {
      duration: 5,
      count: 1,
    },
  },
  detectRetina: true,
};
